module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-info-wrapper"
  }, [_c('div', {
    staticClass: "patient-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentSchedule.patient.med_record_number)), _c('small', [_vm._v(_vm._s(_vm.currentSchedule.patient.name))])]), (_vm.currentSchedule.bed) ? _c('span', [_vm._v("病床：" + _vm._s(_vm.currentSchedule.bed.code))]) : _vm._e()]), _c('div', {
    staticClass: "gender-img"
  }, [(_vm.currentSchedule.patient.gender === 'male') ? _c('img', {
    attrs: {
      "src": "static/svg/masculine.svg"
    }
  }) : _vm._e(), (_vm.currentSchedule.patient.gender === 'female') ? _c('img', {
    attrs: {
      "src": "static/svg/femenine.svg"
    }
  }) : _vm._e(), (_vm.currentSchedule.patient.gender === null) ? _c('span', [_vm._v("性別未定義")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf1ad42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/PatientInfo.vue
// module id = 1499
// module chunks = 1